import React, { useState } from 'react';

// Shared "Web Link + LINE LIFF" copy panel for the APFS redirectURL.
// The LIFF variant keeps the path + query (token, type, ...) identical and
// only swaps the origin, so the same token works inside the LINE app.

const APFS_WEB_ORIGIN = 'https://agentportal.apfsenterprise.com';
const APFS_LINE_LIFF_ORIGIN = 'https://liff.line.me/2009865135-c8H7uizj';

export function toLineLiffUrl(url) {
  if (!url || typeof url !== 'string') return null;
  if (!url.startsWith(APFS_WEB_ORIGIN)) return null;
  return APFS_LINE_LIFF_ORIGIN + url.slice(APFS_WEB_ORIGIN.length);
}

const styles = {
  link: { marginTop: 6 },
  linkLabel: { fontSize: 12, fontWeight: 600, color: '#4f46e5', marginBottom: 4 },
  row: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' },
  input: {
    flex: '1 1 240px',
    minWidth: 0,
    padding: '8px 10px',
    fontSize: 13,
    color: '#111827',
    background: '#fff',
    border: '1px solid #c7d2fe',
    borderRadius: 6,
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace'
  },
  copyBtn: {
    flex: '0 0 auto',
    padding: '8px 12px',
    fontSize: 13,
    fontWeight: 600,
    color: '#fff',
    background: '#6366f1',
    border: '1px solid #6366f1',
    borderRadius: 6,
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  },
  openLink: {
    flex: '0 0 auto',
    padding: '8px 12px',
    fontSize: 13,
    fontWeight: 600,
    color: '#3730a3',
    background: '#fff',
    border: '1px solid #c7d2fe',
    borderRadius: 6,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textDecoration: 'none'
  }
};

export default function RedirectLinks({ url }) {
  const [copied, setCopied] = useState(null);

  if (!url) return null;

  const liff = toLineLiffUrl(url);

  const copy = async (value, key) => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied((c) => (c === key ? null : c)), 1500);
    } catch {
      // Fallback for older browsers / insecure contexts
      const ta = document.createElement('textarea');
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); setCopied(key); } catch {}
      document.body.removeChild(ta);
      setTimeout(() => setCopied((c) => (c === key ? null : c)), 1500);
    }
  };

  const renderRow = (label, value, key) => (
    <div style={styles.link}>
      <div style={styles.linkLabel}>{label}</div>
      <div style={styles.row}>
        <input
          type="text"
          readOnly
          value={value}
          onFocus={(e) => e.target.select()}
          style={styles.input}
        />
        <button type="button" onClick={() => copy(value, key)} style={styles.copyBtn}>
          {copied === key ? '✅ คัดลอกแล้ว' : '📋 คัดลอก'}
        </button>
        <a href={value} target="_blank" rel="noreferrer" style={styles.openLink}>
          เปิด ↗
        </a>
      </div>
    </div>
  );

  return (
    <div>
      {renderRow('1) Web Link', url, 'web')}
      {liff && renderRow('2) Line Liff', liff, 'line')}
    </div>
  );
}
